import theme from 'styled-theming';
import { DarkTheme } from 'styles/themes/dark';
import { KCFThemeValue, ThemeType } from 'styles/themes/KCFTheme';
import { LightTheme } from 'styles/themes/light';

const createColorEntry = (property: string): theme.ThemeSet => {
    const sheetMapping: { [key in ThemeType]: KCFThemeValue } = {
        light: LightTheme[property as keyof typeof LightTheme],
        dark: DarkTheme[property as keyof typeof DarkTheme],
    };
    return theme('colorMode', sheetMapping);
};

export const bodyBackgroundColor = createColorEntry('bodyBackgroundColor');
export const backgroundColor = createColorEntry('backgroundColor');
export const backgroundColorActive = createColorEntry('backgroundColorActive');
export const shadeBackgroundColor = createColorEntry('shadeBackgroundColor');
export const secondaryBackgroundColor = createColorEntry('secondaryBackgroundColor');

export const activeBackgroundColor1 = createColorEntry('activeBackgroundColor1');
export const activeBackgroundColor2 = createColorEntry('activeBackgroundColor2');

export const borderColor = createColorEntry('borderColor');
export const navColor = createColorEntry('navColor');
export const navBorderColor = createColorEntry('navBorderColor');
export const primaryText = createColorEntry('primaryText');
export const secondaryText = createColorEntry('secondaryText');
export const disabledText = createColorEntry('disabledText');
export const primaryBoxShadow = createColorEntry('primaryBoxShadow');
export const modalBoxShadow = createColorEntry('modalBoxShadow');
export const menuBoxShadow = createColorEntry('menuBoxShadow');

export const link = createColorEntry('link');
export const linkShifted = createColorEntry('linkShifted');

export const title = createColorEntry('title');

export const cancelButton = createColorEntry('cancelButton');
export const secondaryButton = createColorEntry('secondaryButton');
export const secondaryButtonHover = createColorEntry('secondaryButtonHover');
export const cancelButtonHover = createColorEntry('cancelButtonHover');
export const iconButtonBackgroundHover = createColorEntry('iconButtonBackgroundHover');
export const deleteButton = createColorEntry('deleteButton');
export const deleteButtonHover = createColorEntry('deleteButtonHover');
export const warningButton = createColorEntry('warningButton');
export const warningButtonHover = createColorEntry('warningButtonHover');

// Form elements
export const inputBorder = createColorEntry('inputBorder');
export const inputBorderFocused = createColorEntry('inputBorderFocused');
export const inputBorderInvalid = createColorEntry('inputBorderInvalid');
export const inputBorderValid = createColorEntry('inputBorderValid');
export const filterRadioButton = createColorEntry('filterRadioButton');

export const infoBox = createColorEntry('infoBox');

// Asset Cards
export const assetCardReportBackgroundColor = createColorEntry(
    'assetCardReportBackgroundColor'
);

// Charts
export const chartBackgroundColor = createColorEntry('chartBackgroundColor');
export const chartPlotGridBackgroundColor = createColorEntry(
    'chartPlotGridBackgroundColor'
);

// Workbench Tree
export const workbenchHeader = createColorEntry('workbenchHeader');
export const workbenchHeaderButtonHover = createColorEntry('workbenchHeaderButtonHover');

// Timeseries
export const timeseriesBackgroundColor = createColorEntry('timeseriesBackgroundColor');
export const timeseriesAxisColor = createColorEntry('timeseriesAxisColor');
export const timeseriesGridColor = createColorEntry('timeseriesGridColor');
export const timeseriesDrawerUnselectedColor = createColorEntry(
    'timeseriesDrawerUnselectedColor'
);
export const activityLineColor = createColorEntry('activityLineColor');
export const markerTableSelectedColor = createColorEntry('markerTableSelectedColor');

// treeview
export const treeviewIconColor = createColorEntry('treeviewIconColor');

// notifications
export const notificationsCog = createColorEntry('notificationsCog');
export const notificationsHeaderText = createColorEntry('notificationsHeaderText');

// Tabs
export const tabSelected = createColorEntry('tabSelected');
export const tabsBottomBorder = createColorEntry('tabsBottomBorder');

// popup
export const popupText = createColorEntry('popupText');
export const popupBackgroundColor = createColorEntry('popupBackgroundColor');

export const issueQueueButtonBackgroundColor = createColorEntry(
    'issueQueueButtonBackgroundColor'
);

export const kcfOnlyLozengeBackground = createColorEntry('kcfOnlyLozengeBackground');
export const kcfOnlyLozengeText = createColorEntry('kcfOnlyLozengeText');

// Icons
export const iconColor = createColorEntry('iconColor');

// Hardware Status Action Button
export const hardwareStatusActionButtonBackground = createColorEntry(
    'hardwareStatusActionButtonBackground'
);
export const hardwareStatusActionButtonBackgroundHover = createColorEntry(
    'hardwareStatusActionButtonBackgroundHover'
);

// Alarm severity
export const criticalSeverity = createColorEntry('criticalSeverity');
export const alarmSeverity = createColorEntry('alarmSeverity');
export const warningSeverity = createColorEntry('warningSeverity');

// Toasts
export const successToastColor = createColorEntry('successToastColor');
export const errorToastColor = createColorEntry('errorToastColor');

// Timeseries errors
export const timeseriesErrorIconColor = createColorEntry('timeseriesErrorIconColor');
export const timeseriesErrorBackgroundColor = createColorEntry(
    'timeseriesErrorBackgroundColor'
);

// Dashboard
export const dashboardAccentPrimary = createColorEntry('dashboardAccentPrimary');
export const dashboardAxisText = createColorEntry('dashboardAxisText');
